import {GenericObject} from "./generic-object.model";
import {User} from "./user.model";

/**
 * Model reprezentujący Klienta B2B.
 * Klasa dziedziczy po `GenericObject` (podstawowe pola
 * bazodanowe jak `uuid`).
 * Agreguje wszystkie ustawienia biznesowe, finansowe i prawne dla danego klienta.
 */
export class Client extends GenericObject {

  /** Wewnętrzny identyfikator bazy danych. */
  public id: number;

  /** Typ klienta. */
  public type: string;

  /** Nazwa podmiotu / firmy. */
  public name: string;

  /** Unikalny, krótki kod/ID weterynaryjne przypisane do tej organizacji. */
  public vetCodeId: string;

  /** Dane kontaktowe wsparcia technicznego klienta. */
  public technicalSupport: string;
  // public modified: string;

  /** Lista UUID obrazów, które mają zostać ustawione jako aktywne dla tego klienta. */
  public vImagesToSetAsActive: string[];


  /** Stała opłata transakcyjna za płatności online. */
  public onlineTransactionFee: number;
  /** Procentowa opłata transakcyjna za płatności online. */
  public percentageOnlineTransactionFee: number;
  /** Stała opłata za procesowanie rezerwacji wizyty. */
  public visitTransactionFee: number;
  /** Procentowa opłata za procesowanie rezerwacji wizyty. */
  public percentageVisitTransactionFee: number;
  /** Flaga określająca, czy system ma pobierać opłaty dla tego klienta. */
  public fetchFees: boolean;


  public email: string;
  public phone: string;
  /** NIP (Numer Identyfikacji Podatkowej). */
  public taxId: string;
  /** REGON. */
  public regon: string;
  /** Numer KRS. */
  public krs: string;
  /** Typ działalności gospodarczej. */
  public businessType: number;
  public streetWithNumber: string;
  public city: string;
  public postalCode: string;

  /** * Główny użytkownik-administrator tego klienta.
   * To on ma pełne prawa do zarządzania organizacją w Dashboardzie.
   */
  public admin: User;

  /** Data/znacznik potwierdzenia zgodności z RODO przez organizację. */
  public gdprApproved: string;
  /** Identyfikator użytkownika, który kliknął "Akceptuję RODO" w imieniu firmy. */
  public gdprAcceptedByUser: string;
  /** Imię i nazwisko osoby, która zaakceptowała RODO. */
  public acceptedByUserFirstNameAndLastName: string;
  /** UUID indywidualnego regulaminu RODO klienta (jeśli ma własne zapisy). */
  public individualGDPRTermsUUID: string;

  /** Identyfikator użytkownika, który zaakceptował regulamin integracji z systemem Fakturownia. */
  public fakturowniaAcceptedByUser: string;
  /** Znacznik akceptacji regulaminu integracji z systemem Fakturownia. */
  public fakturowniaApproved: string;


  /** Czy klient ma dostęp do modułu publikacji artykułów. */
  public isArticleModeEnabled: boolean;
  /** Czy klient ma skonfigurowane/przygotowane pakiety usług. */
  public bundlesPrepared: boolean;
  /** Identyfikator powiązanego partnera zewnętrznego. */
  public partnerUUID: string;
  /** Czy klinika obsługuje Pakiety Opieki (Abonamenty). */
  public vetineoCarePlanEnabled: boolean;


  /** Czy włączona jest wysyłka powiadomień SMS z własnej bramki klienta (SMS Serwer). */
  public enableSMSSerwer: boolean;
  /** Login do zewnętrznej bramki SMS klienta. */
  public smsSerwerUser: string;
  /** Hasło do zewnętrznej bramki SMS klienta. */
  public smsSerwerPwd: string;
  /** Nazwa nadawcy SMS (tzw. Sender ID). */
  public smsSerwerSender: string;
  /**
   * Czy wysyłać emaile z raportami do klienta.
   */
  sendEmailWithClientReports: boolean;
  /** Adresy email na które mają być wysyłane raporty */
  clientReportsEmails: string;

  /** Enum mówiący o częstotliwości wysyłania raportów */
  vClientReportType: ClientReportType


  constructor() {
    super()
  }
}

/**
 * Enum definiujący profil działalności klienta.
 */
export enum VClientType {
  /** Klinika Weterynaryjna */
  VET_CLINIC,
  /** Hotel dla zwierząt */
  PET_HOTEL,
  /** Fryzjer dla zwierząt / Groomer */
  GROOMER,
  /** Partner biznesowy */
  PARTNER
}

/**
 * Enum definiujący dostępne częstotliwości raportów klienta
 */
export enum ClientReportType {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY'
}
